export default __webpack_public_path__ + "static/island-life-mobile-5bb339a79f65d19186a9401a36349592.webp";